import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DataClassPathSerializer2aqs8pcwb13zn as DataClassPathSerializer } from './DataClassPathSerializer.mjs';
import {
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from './ConditionSerialization.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Always_getInstance177eud73uc475 as Always_getInstance } from './Condition.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { SortPartSerializerr929bckmbnab as SortPartSerializer } from './SortPartSerializer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.QueryPartial', null, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('fields', false);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        tmp0_serialDesc.addElement_5pzumi_k$('orderBy', true);
        tmp0_serialDesc.addElement_5pzumi_k$('skip', true);
        tmp0_serialDesc.addElement_5pzumi_k$('limit', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer().new_com_lightningkite_services_database_QueryPartial_$serializer_ypupyu_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_QueryPartial_$serializer_lj5tp2_k$();
      }
      static new_com_lightningkite_services_database_QueryPartial_$serializer_lj5tp2_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.QueryPartial', $this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('fields', false);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        tmp0_serialDesc.addElement_5pzumi_k$('orderBy', true);
        tmp0_serialDesc.addElement_5pzumi_k$('skip', true);
        tmp0_serialDesc.addElement_5pzumi_k$('limit', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_axp8bl_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (LinkedHashSetSerializer())(new (DataClassPathSerializer())(this.typeSerial0__1)), value.fields_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !value.condition_1.equals(Always_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), value.condition_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.orderBy_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, new (ArrayListSerializer())(new (SortPartSerializer())(this.typeSerial0__1)), value.orderBy_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.skip_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 3, value.skip_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.limit_1 === 100)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 4, value.limit_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_axp8bl_k$(encoder, value instanceof QueryPartial() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = 0;
        var tmp8_local4 = 0;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (LinkedHashSetSerializer())(new (DataClassPathSerializer())(this.typeSerial0__1)), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, new (ArrayListSerializer())(new (SortPartSerializer())(this.typeSerial0__1)), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (LinkedHashSetSerializer())(new (DataClassPathSerializer())(this.typeSerial0__1)), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, new (ArrayListSerializer())(new (SortPartSerializer())(this.typeSerial0__1)), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return QueryPartial().new_com_lightningkite_services_database_QueryPartial_nms1r_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (LinkedHashSetSerializer())(new (DataClassPathSerializer())(this.typeSerial0__1)), new (ConditionSerializer())(this.typeSerial0__1), new (ArrayListSerializer())(new (SortPartSerializer())(this.typeSerial0__1)), IntSerializer_getInstance(), IntSerializer_getInstance()];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_QueryPartial_$serializer_ypupyu_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_QueryPartial_$serializer_lj5tp2_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var QueryPartialClass;
function QueryPartial() {
  if (QueryPartialClass === VOID) {
    class $ {
      constructor(fields, condition, orderBy, skip, limit) {
        Companion_getInstance();
        condition = condition === VOID ? Always_getInstance() : condition;
        var tmp;
        if (orderBy === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = orderBy;
        }
        orderBy = tmp;
        skip = skip === VOID ? 0 : skip;
        limit = limit === VOID ? 100 : limit;
        this.fields_1 = fields;
        this.condition_1 = condition;
        this.orderBy_1 = orderBy;
        this.skip_1 = skip;
        this.limit_1 = limit;
      }
      toString() {
        return 'QueryPartial(fields=' + toString(this.fields_1) + ', condition=' + toString(this.condition_1) + ', orderBy=' + toString(this.orderBy_1) + ', skip=' + this.skip_1 + ', limit=' + this.limit_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.fields_1);
        result = imul(result, 31) + this.condition_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.orderBy_1) | 0;
        result = imul(result, 31) + this.skip_1 | 0;
        result = imul(result, 31) + this.limit_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof QueryPartial()))
          return false;
        if (!equals(this.fields_1, other.fields_1))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        if (!equals(this.orderBy_1, other.orderBy_1))
          return false;
        if (!(this.skip_1 === other.skip_1))
          return false;
        if (!(this.limit_1 === other.limit_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_QueryPartial_nms1r_k$(seen0, fields, condition, orderBy, skip, limit, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.fields_1 = fields;
        if (0 === (seen0 & 2))
          $this.condition_1 = Always_getInstance();
        else
          $this.condition_1 = condition;
        if (0 === (seen0 & 4)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.orderBy_1 = emptyList();
        } else
          $this.orderBy_1 = orderBy;
        if (0 === (seen0 & 8))
          $this.skip_1 = 0;
        else
          $this.skip_1 = skip;
        if (0 === (seen0 & 16))
          $this.limit_1 = 100;
        else
          $this.limit_1 = limit;
        return $this;
      }
    }
    initMetadataForClass($, 'QueryPartial', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    QueryPartialClass = $;
  }
  return QueryPartialClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3d34otlkn11wr,
};
//endregion

//# sourceMappingURL=QueryPartial.mjs.map
